// vim: ft=javascriptreact
import { useEffect, useState } from 'react'
import {
  Row,
  Col,
  Button,
  Spinner,
  Alert,
  Badge,
} from 'react-bootstrap'
import {
  useParams,
} from 'react-router-dom'
import useResidents from '../../hooks/useResidents'
import BookingsListing from '../../BookingsListing'
import Note from '../../Note'
import { formatPhone } from '../../utils';
import classnames from 'classnames'
import './styles.scss'

const ResidentViewer = () => {
  const { residentId } = useParams()
  const {
    residentsLoaded,
    getResident,
    getResidentBookings,
    bookings,
    bookingsLoaded,
    disableResident,
    getResidentNotes,
  } = useResidents(true)

  const [notes, setNotes] = useState([])
  const [notesLoaded, setNotesLoaded] = useState(false)

  useEffect(() => {
    if (!bookingsLoaded) {
      getResidentBookings(residentId)
    }
  }, [bookingsLoaded])

  useEffect(() => {
    if (!notesLoaded) {
      getResidentNotes(residentId).then((data) => {
        setNotes(data)
        setNotesLoaded(true)
      });
    }
  }, [notesLoaded]);

  if (!residentsLoaded) {
    return (
      <Spinner animation="border" role="status" variant="primary" className="mb-2" />
    )
  }

  const resident = getResident(residentId)
  const {
    first_name: firstName,
    last_name: lastName,
    email,
    unit,
    phone,
    pad_set_up: padSetUp,
    user_id: userId,
    disabled,
  } = resident

  const setDisabled = async () => {
    await disableResident(residentId)
  }

  return (
    <div>
      <Row>
        <Col sm={9}>
          <h2>{firstName} {lastName}</h2>
        </Col>

        <Col sm={3}>
          <h2 className="resident-unit">Unit {unit}</h2>
        </Col>
      </Row>

      <Row>
        <Col sm={9}>
          <h4>{email}</h4>
          <h4>{formatPhone(phone)}</h4>
          {!disabled && <Button variant="danger" onClick={() => { disableResident(residentId) }}>Disable Resident</Button> }
          {disabled && <Badge bg="danger">Disabled</Badge>}
        </Col>

        <Col sm={3}>
          <h4>
            <i className={classnames('fa', { 'fa-credit-card': padSetUp, 'fa-do-not-enter': !padSetUp })} title={padSetUp ? 'PAD Set Up' : 'PAD Not Set Up'} />
          </h4>
        </Col>
      </Row>

      <div className="resident-notes mt-3">
        {notes && notes.length > 0 && (
          <>
            <h3>Notes</h3>
            <div className="booking-notes">
              {notes.map((note) => (<Note id={note.id} note={note.note} createdAt={note.created_at} />))}
            </div>
          </>
        )}
      </div>

      <div className="resident-bookings mt-3">
        {!bookingsLoaded && <Spinner animation="border" role="status" variant="primary" className="mb-2" />}

        {bookingsLoaded && (
          <BookingsListing
            isAdmin
            bookingsOverride={bookings}
            noBookings={() => (
              <Alert variant="warning">
                No bookings found.
              </Alert>
              )
            }
          />
        )}
      </div>

      <div className="mt-5">
        <small className="muted">Ref: {residentId} / {userId}</small>
      </div>
    </div>
  )
}

export default ResidentViewer
